// extracted by mini-css-extract-plugin
module.exports = {"container":"_6eb00b8e53--container---SwrW","frameless":"_6eb00b8e53--frameless--1_-9h","buttons":"_6eb00b8e53--buttons--7w4sU","error":"_6eb00b8e53--error--2ecaZ"};